import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { space } from '@guardian/src-foundations';
import { neutral } from '@guardian/src-foundations/palette';
import { body } from '@guardian/src-foundations/typography';
import { SvgAlertRound } from '@guardian/src-icons';
import { YoutubeAtom } from '@guardian/atoms-rendering';
import { trackVideoInteraction } from '@root/src/web/browser/ga/ga';
import { record } from '@root/src/web/browser/ophan/ophan';
import { Caption } from '@root/src/web/components/Caption';
const expiredOverlayStyles = (overrideImage) => css `
	height: 0px;
	position: relative;
	background-image: url(${overrideImage});
	background-size: cover;
	background-position: 49% 49%;
	background-repeat: no-repeat;
	padding-bottom: 56%;
	color: ${neutral[100]};
	background-color: ${neutral[20]};
`;
const expiredTextWrapperStyles = css `
	display: flex;
	flex-direction: row;
	align-items: center;

	padding-top: ${space[4]}px;
	padding-bottom: ${space[4]}px;
	padding-left: ${space[1]}px;
	padding-right: ${space[12]}px;
	color: ${neutral[100]};
	background-color: ${neutral[20]};
`;
const expiredSVGWrapperStyles = css `
	padding-right: ${space[1]}px;
	svg {
		width: ${space[12]}px;
		height: ${space[12]}px;
		fill: ${neutral[100]};
	}
`;
export const YoutubeBlockComponent = ({ id, assetId, mediaTitle, altText, format, palette, hideCaption, overrideImage, posterImage, expired, role, adTargeting, consentState, isMainMedia, height = 259, width = 460, duration, origin, }) => {
    const shouldLimitWidth = !isMainMedia &&
        (role === 'showcase' || role === 'supporting' || role === 'immersive');
    if (expired) {
        return (_jsxs("figure", Object.assign({ css: css `
					margin-top: 16px;
					margin-bottom: 16px;
				` }, { children: [_jsx("div", Object.assign({ css: overrideImage && expiredOverlayStyles(overrideImage) }, { children: _jsxs("div", Object.assign({ css: expiredTextWrapperStyles }, { children: [_jsx("div", Object.assign({ css: expiredSVGWrapperStyles }, { children: _jsx(SvgAlertRound, {}, void 0) }), void 0), _jsx("p", Object.assign({ css: css `
								${body.medium({
                                    lineHeight: 'tight',
                                })}
							` }, { children: "This video has been removed. This could be because it launched early, our rights have expired, there was a legal issue, or for another reason." }), void 0)] }), void 0) }), void 0), !hideCaption && (_jsx(Caption, { palette: palette, captionText: mediaTitle || '', format: format, displayCredit: false, shouldLimitWidth: shouldLimitWidth, mediaType: "Video" }, void 0))] }), void 0));
    }
    const ophanTracking = (trackingEvent) => {
        if (!id)
            return;
        record({
            video: {
                id: `gu-video-youtube-${id}`,
                eventType: `video:content:${trackingEvent}`,
            },
        });
    };
    const gaTracking = (trackingEvent) => {
        if (!id)
            return;
        trackVideoInteraction({
            trackingEvent,
            elementId: id,
        });
    };
    return (_jsxs("div", Object.assign({ "data-chromatic": "ignore", "data-component": "youtube-atom" }, { children: [_jsx(YoutubeAtom, { assetId: assetId, overrideImage: overrideImage
                    ? [
                        {
                            srcSet: [
                                {
                                    src: overrideImage,
                                    width: 500, // we do not have width for overlayImage so set a random number
                                },
                            ],
                        },
                    ]
                    : undefined, posterImage: posterImage
                    ? [
                        {
                            srcSet: posterImage.map((img) => ({
                                src: img.url,
                                width: img.width,
                            })),
                        },
                    ]
                    : undefined, role: role, alt: altText || mediaTitle || '', adTargeting: adTargeting, consentState: consentState, height: height, width: width, title: mediaTitle, duration: duration, eventEmitters: [ophanTracking, gaTracking], pillar: format.theme, origin: process.env.NODE_ENV === 'development' ? '' : origin }, void 0), !hideCaption && (_jsx(Caption, { palette: palette, captionText: mediaTitle || '', format: format, displayCredit: false, shouldLimitWidth: shouldLimitWidth, mediaType: "Video" }, void 0))] }), void 0));
};
